<template>
  <div
    :class="cardClass"
    @click="handleClick"
  >
    <nuxt-img
      v-if="image && image.src"
      class="c-brand-card__image"
      v-bind="$getImgOptions(image)"
    />
  </div>
</template>

<script>
import { UrlFilters } from '@mixins/cdnMixins'
export default {
  mixins: [ UrlFilters ],
  props: {
    image: {
      type: Object,
      default: () => {},
    },
    url: {
      type: String,
      default: ''
    },
    darkBackground: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    cardClass() {
      let result = ['c-brand-card']
      const darkBackground = this.darkBackground
      if(darkBackground) {
        result.push('c-brand-card--dark')
      }
      return result
    }
  },
  methods: {
    handleClick() {
      this.$router.push(this.url)
    },
  },
};
</script>

<style lang="scss" scoped>
.c-brand-card {
  cursor: pointer;
  height: rem(100px);
  width: rem(180px);
  margin-right: rem(10px);
  display: flex;
  border-radius: rem(10px);
  justify-content: center;
  align-items: center;
  padding: rem(10px);
  &__image {
    max-height: rem(100px);
    max-width: rem(160px);
    object-fit: contain;
    padding: rem(10px);
  }
  &--dark {
    @include themify($themes) {
      background-color: themed('foreground', 'light-text');
    }
  }
}
</style>
